module.exports = __webpack_public_path__ + "static/img/Huang_Kuo-chao.png";